import { merge } from '../helper';

import type { IInputConfig } from './input/types';

import * as exInput from './input';

// ----------------------------------------------------------------------------

export interface IDatetimeConfig {
    input?: IInputConfig;
}

export type TypeDatetimeBuild = {
    element: HTMLElement;
    inputGroup: Record<string, any>;
    input: HTMLElement;
};

// ----------------------------------------------------------------------------

function create(config: IDatetimeConfig = {}): TypeDatetimeBuild {
    // Default Config
    const defConfig: IDatetimeConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    const elements = {} as TypeDatetimeBuild;

    // Create element (input group)
    const inputGroup = exInput.group.create({
        merge: defConfig,
        class: {
            new: 'datetimepicker',
        },
    });
    elements.element = inputGroup.element;
    elements.inputGroup = inputGroup;

    // Create element (input datetime)
    const input = exInput.create({
        merge: defConfig.input,
        type: 'datetime-local',
    });
    inputGroup.element.appendChild(input.element);
    elements.input = input.element;

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

function regexFormat(str: string, pattern: string): string {
    let i = 0;

    const value = String(str);

    return pattern.replace(/#/g, (): any => value[i++] ?? '');
}

// ----------------------------------------------------------------------------

export { create, regexFormat };
